<script setup>
import GuestLayout from '@/layouts/GuestLayout.vue';
import PrimaryButton from '@/components/PrimaryButton.vue';
import TextInput from '@/components/TextInput.vue';


const props = defineProps({
    email: {
        type: String,
        required: true,
    },
    token: {
        type: String,
        required: true,
    },
});

const form = useForm({
    token: props.token,
    email: props.email,
    password: '',
    password_confirmation: '',
});

const submit = () => {
    form.post(route('app.password.store'), {
        onFinish: () => form.reset('password', 'password_confirmation'),
    });
};
</script>

<template>
    <GuestLayout>

        <Head title="Reset Password" />

        <form @submit.prevent="submit">
            <div>
                <TextInput label="Email" id="email" type="email" class="mt-1 block w-full" v-model="form.email"
                    :errors="errors.email" required autofocus autocomplete="username" />
            </div>

            <div class="mt-4">
                <TextInput label="Mật Khẩu" id="password" type="password" class="mt-1 block w-full"
                    v-model="form.password" :errors="errors.password" required autocomplete="new-password" />
            </div>

            <div class="mt-4">
                <TextInput label="Xác nhận mật khẩu" id="password_confirmation" type="password"
                    class="mt-1 block w-full" v-model="form.password_confirmation"
                    :errors="errors.password_confirmation" required autocomplete="new-password" />
            </div>

            <div class="flex items-center justify-end mt-4">
                <PrimaryButton :class="{ 'opacity-25': form.processing }" :disabled="form.processing">
                    Reset Password
                </PrimaryButton>
            </div>
        </form>
    </GuestLayout>
</template>
